var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 847,
    viewBox: "0 0 1440 847",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 763,
    transform: "translate(0 84)",
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.994 169.034C208.193 74.8735 131.211 -0.802947 37.05 0.00643231C-57.1111 0.815812 -132.795 77.8045 -131.994 171.966C-131.193 266.126 -54.211 341.803 39.95 340.994C134.111 340.184 209.795 263.195 208.994 169.034ZM127.915 168.736C127.484 118.054 86.2657 77.319 35.8517 77.7523C-14.5623 78.1857 -55.0814 119.623 -54.6504 170.305C-54.2193 220.987 -13.0013 261.722 37.4127 261.288C87.8266 260.855 128.346 219.418 127.915 168.736Z",
    fill: "#FF6000",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1824.99 462.387C1823.56 294.499 1686.3 159.568 1518.41 161.011C1350.53 162.455 1215.58 299.725 1217.01 467.613C1218.44 635.501 1355.7 770.432 1523.59 768.989C1691.47 767.545 1826.42 630.275 1824.99 462.387ZM1680.43 461.854C1679.66 371.489 1606.17 298.859 1516.28 299.632C1426.39 300.404 1354.15 374.287 1354.91 464.652C1355.68 555.018 1429.17 627.648 1519.06 626.875C1608.95 626.102 1681.19 552.22 1680.43 461.854Z",
    fill: "#FF6000",
    fillOpacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductBg);
export default __webpack_public_path__ + "static/media/product-bg.3889771e3bb537cc251bedffa3b549c0.svg";
export { ForwardRef as ReactComponent };